import { queryOptions } from '@tanstack/react-query';

import { fetchBackend } from '../../apiClient';

export type GithubConfig = {
  id: string;
  installation_id: string;
  orgName: string;
  orgType: 'User' | 'Organization';
  repositories: string[];
};

export type GithubConfigForList = {
  id: string;
  projectId: string;
  createdAt: string;
  updatedAt: string;
};

export const githubConfigQueries = {
  all: () => ['github-configs'],
  byProject: (projectId: string) => [...githubConfigQueries.all(), projectId],
  list: (projectId: string) =>
    queryOptions({
      queryKey: ['github-configs', projectId],
      queryFn: async () => {
        const githubConfigs = await listGithubConfigs(projectId);

        return githubConfigs;
      },
    }),
} as const;

export const listGithubConfigs = async (
  projectId: string,
): Promise<GithubConfig[]> => {
  const getResponse = await fetchBackend(`/github-config/${projectId}`, {
    method: 'GET',
  });

  if (!getResponse.ok) {
    throw new Error(`Error: ${getResponse.statusText}`);
  }

  return (await getResponse.json()) as GithubConfig[];
};

export const exchangeCodeForToken = async (
  projectId: string,
  code: string,
): Promise<string> => {
  const postResponse = await fetchBackend(
    `/github-config/${projectId}/exchange-token`,
    {
      method: 'POST',
      body: JSON.stringify({ code }),
    },
  );

  if (!postResponse.ok) {
    throw new Error(`Error: ${postResponse.statusText}`);
  }

  const { accessToken } = (await postResponse.json()) as {
    accessToken: string;
  };

  return accessToken;
};

export const createGithubConfiguration = async (
  projectId: string,
  githubToken: string,
): Promise<void> => {
  const postResponse = await fetchBackend(`/github-config/${projectId}`, {
    method: 'POST',
    body: JSON.stringify({
      githubToken,
    }),
  });

  if (!postResponse.ok) {
    throw new Error(`Error: ${postResponse.statusText}`);
  }
};
